import "esbuild-css-modules-plugin-ns-css:src/js/components/breadcrumbs/breadcrumbs.module.css";

import { inject } from "esbuild-css-modules-plugin-ns-js:src/js/components/breadcrumbs/breadcrumbs.module.css:injector.js";
export default new Proxy({
  "breadcrumbsContainer": "breadcrumbs-module__breadcrumbsContainer_Iz47XW__1100",
  "linksContainer": "breadcrumbs-module__linksContainer_Iz47XW__1100"
}, {
  get: function(source, key) {
    inject();
    return source[key];
  }
});
      